import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {
  DialogActions,
  FormControl,
  Box,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";

import useStyles from "../styles";
import { DialogContent, DialogTitle } from "components/common/DialogApi";
import { useSelector } from "react-redux";
import useSettingsAction from "../actions";
import PasswordField from "components/common/PasswordField";
import { checkPasswordStrength } from "components/User/Validation";
import Transition from "components/common/Transition";

const ChangePassword = () => {
  const classes = useStyles();
  const { isChgPwdDialogOpen, pwdChangeContent } = useSelector(
    (state) => state.settings
  );
  const { oldPassword, newPassword, verifyPassword } = useSelector(
    (state) => state.settings.pwdChangeContent
  );
  const { openPwdChangeDialog, setPwdDialogContent, onPasswordChange } =
    useSettingsAction();
  const [isFormValid, setIsFormValid] = useState(false);

  const isPasswordMatching = () => {
    return checkPwdEmpty() && newPassword === verifyPassword;
  };
  const checkPwdEmpty = () => {
    return newPassword && verifyPassword;
  };

  const [fieldChecked, setFieldChecked] = useState({
    newPassword: false,
    verifyPassword: false,
  });

  const getHelperText = () => {
    return fieldChecked.verifyPassword
      ? !isPasswordMatching()
        ? checkPwdEmpty()
          ? "Passwords do not match"
          : "Password Cannot be empty"
        : "Passwords match"
      : "";
  };
  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    let checkFields =
      checkPasswordStrength(newPassword) && oldPassword && verifyPassword;
    checkFields = newPassword === verifyPassword && checkFields;
    setIsFormValid(checkFields);
  };
  const onCloseDialog = () => {
    setFieldChecked({ newPassword: false, verifyPassword: false });
    openPwdChangeDialog(false);
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Dialog
      fullScreen={!matches}
      TransitionComponent={Transition}
      disableBackdropClick
      open={isChgPwdDialogOpen}
      fullWidth
      aria-labelledby="reset-dialog"
    >
      <DialogTitle id="reset-dialog" onClose={() => onCloseDialog()}>
        <Grid container justify="center">
          <Typography variant="h5">Change Password</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          item
          className={classes.content}
          direction="column"
          justify="center"
          alignContent="center"
        >
          <Box>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                size="small"
                type="password"
                label="Old Password"
                variant="outlined"
                value={oldPassword}
                onChange={(e) => {
                  setPwdDialogContent({
                    ...pwdChangeContent,
                    oldPassword: e.target.value,
                  });
                }}
              />
            </FormControl>
            <FormControl fullWidth className={classes.formControl}>
              <PasswordField
                size="small"
                type="password"
                label="New Password"
                variant="outlined"
                value={newPassword}
                error={
                  fieldChecked.newPassword &&
                  !checkPasswordStrength(newPassword)
                }
                onChange={(e) => {
                  setPwdDialogContent({
                    ...pwdChangeContent,
                    newPassword: e.target.value,
                  });
                }}
                onClick={() => {
                  setFieldChecked({
                    ...fieldChecked,
                    newPassword: true,
                  });
                }}
              />
            </FormControl>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                size="small"
                type="password"
                error={fieldChecked.verifyPassword && !isPasswordMatching()}
                helperText={getHelperText()}
                label="Verify Password"
                variant="outlined"
                value={verifyPassword}
                onChange={(e) => {
                  setPwdDialogContent({
                    ...pwdChangeContent,
                    verifyPassword: e.target.value,
                  });
                }}
                onClick={() => {
                  setFieldChecked({
                    ...fieldChecked,
                    verifyPassword: true,
                  });
                }}
              />
            </FormControl>
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth={!matches}
          onClick={() => onCloseDialog()}
        >
          Cancel
        </Button>
        <Button
          fullWidth={!matches}
          variant="contained"
          disabled={!isFormValid}
          color="primary"
          onClick={() => onPasswordChange(onCloseDialog)}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePassword;
